<template>
  <a class="company-card-main" :href="`/company/${data.token || ''}.html`" target="_blank">
    <div class="company-picture">
      <img :src="data.company_logo" alt="">
    </div>
    <div class="company-name text-overflow">{{data.company_nickname || data.company_full_name}}</div>
    <div class="company-info text-overflow">
      {{data.city || '全国'}}
      <span> · </span>
      <template v-if="showPhase">
        <span v-if="data.phase && data.phase!=='不需要融资'">{{data.phase}} · </span>
      </template>
      <template v-else>
        {{data.company_type}}
        <span v-if="data.company_type"> · </span>
      </template>
      {{data.scale}}
      <span v-if="data.scale"> · </span>
    </div>
    <div class="company-btn"><span class="num" v-if="data.jobs_count">{{data.jobs_count}}个  </span>职位正在热招</div>
  </a>
</template>
<script>

export default {
  name: 'companyItem',
  props: {
    data: {
      type: Object
    },
    showPhase:{
      type: Boolean,
      default: false
    },
  }
}
</script>
<style lang="scss" scoped>
.company-card-main {
  width: 287px;
  height: 238px;
  padding: 30px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
  &:hover {
    box-shadow: 0px 2px 28px 0px rgba(10, 44, 156, 0.1);
    .company-btn{
      color: #ff6644;
      border: 1px solid #FF6644;
    }
  }
  &>div {
    text-align: center;
  }
  .company-picture {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    border-radius: 4px;
    border: 1px solid #F9F9F9;
    img {
      max-width: 60px;
      max-height: 60px;
      border-radius: 4px;
    }
  }
  .company-name {
    height: 18px;
    line-height: 18px;
    margin-top: 20px;
    font-size: 16px;
    color: #404040;
    font-weight: 500;
  }
  .company-info {
    height: 14px;
    line-height: 14px;
    margin-top: 12px;
    font-size: 14px;
    color: #9C9C9C;
    span:last-child {
      display: none;
    }
  }
  .company-btn {
    margin: 20px auto 0;
    width: 180px;
    height: 34px;
    line-height: 34px;
    border: 1px solid #ECECEC;
    font-size: 14px;
    color: #606060;
    border-radius: 2px;
    cursor: pointer;
    span{
      color: #FF4F4C;
    }
  }
}
</style>
